const baseField = "w-full px-4 py-3.5 rounded-xl appearance-none bg-steel-50 border border-transparent text-navy-900 placeholder:text-steel-400 hover:bg-steel-100 focus:outline-none focus:bg-white focus:border-navy-600 focus:ring-4 focus:ring-navy-600/10 transition-all";

export const Field = ({ label, name, type = 'text', value, onChange, required, placeholder }) => (
    <div>
        <label className="block text-sm font-semibold text-navy-900 mb-2">
            {label} {required && <span className="text-signal">*</span>}
        </label>
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            className={baseField}
        />
    </div>
);

export const Select = ({ label, name, value, onChange, options, required }) => (
    <div>
        <label className="block text-sm font-semibold text-navy-900 mb-2">
            {label} {required && <span className="text-signal">*</span>}
        </label>
        <div className="relative">
            <select
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                className={`${baseField} pr-11 cursor-pointer`}
            >
                <option value="">Select…</option>
                {options.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
            <ChevronDown />
        </div>
    </div>
);

export const Textarea = ({ label, name, value, onChange, required, placeholder, rows = 4 }) => (
    <div>
        <label className="block text-sm font-semibold text-navy-900 mb-2">
            {label} {required && <span className="text-signal">*</span>}
        </label>
        <textarea
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            rows={rows}
            className={`${baseField} resize-y leading-relaxed`}
        />
    </div>
);

export const FormSection = ({ title, children }) => (
    <div>
        {title && <p className="text-xs font-semibold text-steel-500 uppercase tracking-[0.15em] mb-4">{title}</p>}
        {children}
    </div>
);

const ChevronDown = () => (
    <svg
        className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-steel-500"
        width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2.5"
        strokeLinecap="round" strokeLinejoin="round"
    >
        <polyline points="6 9 12 15 18 9" />
    </svg>
);
